var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 5.55454H9.16667V3.70303C9.16667 1.66081 7.52217 0 5.5 0C3.47783 0 1.83333 1.66081 1.83333 3.70303V5.55454H1.375C0.617222 5.55454 0 6.17727 0 6.94318V13.4235C0 14.1894 0.617222 14.8121 1.375 14.8121H9.625C10.3828 14.8121 11 14.1894 11 13.4235V6.94318C11 6.17727 10.3828 5.55454 9.625 5.55454ZM3.05556 3.70303C3.05556 2.34155 4.15189 1.23434 5.5 1.23434C6.84811 1.23434 7.94444 2.34155 7.94444 3.70303V5.55454H3.05556V3.70303ZM6.11111 10.3203V11.7263C6.11111 12.0669 5.83794 12.3434 5.5 12.3434C5.16206 12.3434 4.88889 12.0669 4.88889 11.7263V10.3203C4.52528 10.1062 4.27778 9.71242 4.27778 9.25757C4.27778 8.57683 4.82594 8.02323 5.5 8.02323C6.17406 8.02323 6.72222 8.57683 6.72222 9.25757C6.72222 9.71242 6.47472 10.1062 6.11111 10.3203Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.55072beffc0b8c497b4284cbb2c338c6.svg";
export { ForwardRef as ReactComponent };